import React from 'react';
import styled, { injectGlobal, css } from 'react-emotion';
import {
  space, color, width, height,
} from 'styled-system';
import { Icon } from 'antd';

const hours = [...Array(24).keys()].map(i => i < 10 ? `0${i}` : `${i}`);

const fullHours = [...hours, ...hours].sort().map((hour, i) => `${hour}:${i % 2 === 0 ? '00' : '30'}`);

export const Empty = styled('div')`
  font-size: 1.3rem;
  position: absolute;
  left: calc(50% - 100px);
  top: 50%;
  width: 200px;
  text-align: center;
`;

export const BktGridInjectedSpecialLink = styled('a')`
  ${color}
  > * {
    ${color}
  }
`;

export const BktGridInjectedSpecialText = styled('span')`
  ${color}
  > * {
    ${color}
  }
`;

export const BktGridInjectedIcons = styled(Icon)`
  > * {
    ${space}
    ${color}
  }
`;

export const BktGridInjectedUI = styled(
  props => <span title="" {...props} />,
)`
  > * {
    cursor: pointer;
    ${space}
    ${color}

    .ant-checkbox::after {
      width: 0%;
      height: 0%;
    }
  }
`;

export const DCRPScenarioComparePopOverStyle = injectGlobal`
  .DCRPScenarioComparePopOver {
    width: 50vw;
  }

  .popup .form-group {
    min-width: 15em;

    #time-mask,
    .input-sm,
    .react-datepicker__input-container > input,
    .react-datepicker__input-container .react-datepicker-ignore-onclickoutside {
      &:hover {
        border: 1px solid rgba(191,191,191,.87);
      }

      border: 1px solid rgba(34,36,38,.15);
      padding: 4px !important;
      border-radius: 4px;
    }
  }
`;

export const GridContainer = styled('div')`
  ${width}
  ${height}
  position: relative;
  &.DCRPRemoveGapsInBktGrid .ReactVirtualized__Table__headerColumn,
  &.DCRPRemoveGapsInBktGrid .ReactVirtualized__Table__rowColumn {
    margin-right: 0 !important;
  }

  /* TODO: There has to be a better way to style grid subcomponents. */
  >div>div {
    /* Main Grid */
    :nth-child(1){
      /* The Edit/Delete buttons */
      div.ReactVirtualized__Table__rowColumn:last-child {

        /* Default state */
        .inactive {
          /* Delete */
          div:nth-child(2) {
            display: ${({ isNotDeletable }) => isNotDeletable ? 'none' : 'flex'}
          }
        }
      }
    }

    /* Grid footer bar */
    :nth-child(2) {
      position: absolute;
      bottom: 0;

      /* Paginatior */
      .column:nth-child(1) {
        margin: 12px;

        .buttons {
          margin: 0 2px 0;
        }
      }
      
      /* Limit Selector */
      .column:nth-child(2) {
        padding-top: 12px;
      }
    }

    .react-datepicker--time-only > div:nth-child(3) {
      display: none;
    }

    .ReactVirtualized__Table__rowColumn .dropdown.icon {
      padding: 6px !important;
    }
  }

  >div {
    padding: 0;
    aside {
      position: absolute;
      margin: 2px 14px 0;
      font-size: 95%;
      color: ${({ theme }) => theme.colors.greyscale[1]}
    }
  }

  .paginator {
    bottom: -10px !important;
  }

  .bktGrid__HeaderRow {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyscale[3]};
    line-height: 1.2;
    font-size: 12px;
    align-items: flex-end;
    height: inherit !important;

    .ReactVirtualized__Table__headerColumn {
      padding-top: 8px;
      padding-bottom: 6px;
    }
  }
  
  .ReactVirtualized__Grid {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyscale[3]};
  }

  .ReactVirtualized__Table__rowColumn p {
    overflow: hidden;
  }

  .react-grid-HeaderCell-sortable {
    white-space: normal;
    text-transform: uppercase;
  }

  .react-datepicker__time-list-item--selected {
    background-color: white !important;
  }
  
  .react-datepicker__time-list {
    position: relative;
  }

  /* Ridiculous hack until we can get durations working properly in bkt-grid. */
  /* This converts the time menu dropdown items into a 24-hour format. This lets us use Time as Duration for now. */
  ${fullHours.map((hour, i) => css`  
    .react-datepicker__time-list :nth-child(${i + 1}){
      color: white;
      :after {
        position: absolute;
        left: 12px;
        color: black;
        content: '${hour}';
      }
      :hover {
        background-color: white !important;
        font-weight: bold;
      }
    }
  `)}


`;
